import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaHeart } from 'react-icons/fa';
import logo from '../Navbar/logo.png';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Team', href: '#about' },
      { name: 'Careers', href: '#contact' },
      { name: 'Blog', href: '#gallery' }
    ],
    services: [
      { name: 'Photography', href: '#services' },
      { name: 'Videography', href: '#videos' },
      { name: 'Post-Production', href: '#services' },
      { name: 'Consultation', href: '#contact' }
    ],
    resources: [
      { name: 'Portfolio', href: '#gallery' },
      { name: 'Pricing', href: '#services' },
      { name: 'FAQ', href: '#contact' },
      { name: 'Contact', href: '#contact' }
    ]
  };

  const socialLinks = [
    { icon: <FaFacebookF />, href: '#', name: 'Facebook' },
    { icon: <FaInstagram />, href: '#', name: 'Instagram' },
    { icon: <FaTwitter />, href: '#', name: 'Twitter' },
    { icon: <FaYoutube />, href: '#', name: 'YouTube' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="Logo" className="footer-logo-image" />
            </div>
            <p className="footer-tagline">
              Capturing moments, creating memories. Professional photography
              and videography services that tell your unique story.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-links-section">
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Services</h4>
              <ul>
                {footerLinks.services.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} Visual Stories. All rights reserved.
          </p>
          <p className="made-with">
            Made with <FaHeart className="heart-icon" /> by passionate creatives
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
